/**************************************************
 * Nombre:       Tarjetas_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Educacion = ({item}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2,pb: 2}}
            spacing={1}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{fontWeight: 300, lineHeight: 1.1, fontSize: 14}}>{`${item.descripcion}`}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Educacion